import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog, IconButton } from "@mui/material";
import type { ReactNode } from "react";
import styles from "./ExtraInfoModal.module.scss";

type ExtraInfoModalProps = {
  open: boolean;
  title: string;
  content: ReactNode;
  onClose: () => void;
};

export default function ExtraInfoModal({
  open,
  title,
  content,
  onClose,
}: ExtraInfoModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: styles.paper }}
      aria-labelledby="extra-info-modal-title"
    >
      <div className={styles.title}>
        <h2 id="extra-info-modal-title" className={styles.heading}>
          {title}
        </h2>
        <IconButton
          className={styles.closeIcon}
          aria-label="Close"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div className={styles.content}>{content}</div>
      <div className={styles.actions}>
        <Button className={styles.closeButton} onClick={onClose}>
          Close
        </Button>
      </div>
    </Dialog>
  );
}
